import React from 'react';
import { getStartupStatusBadge, getEntityProfileUrl } from '/src/components/ICESections/Shared/helpers';
import { parseWebsiteUrl } from '/src/components/ICESections/Shared/mobileListUtils';

// A portfolio row is a startup or a corporate and links to its own profile; "" when the row has no code to build one
export const getPortfolioCompanyUrl = (company) =>
    getEntityProfileUrl({ id: company.id, code: company.code, type: company.entity_type || 'STARTUP' });

const FundPortfolioTableBody = ({ data = [] }) =>
    data.map((startup, index) => {
        if (!startup) return null;

        const url = getPortfolioCompanyUrl(startup);
        const website = parseWebsiteUrl(startup?.website);

        return (
            <tr key={`startup-row-${startup?.id}-${index}`}>
                <td>
                    {url ? (
                        <a className="funds-raised-table__fund-link" href={url} target="_blank" rel="noopener noreferrer">
                            {startup?.name}
                        </a>
                    ) : startup?.name}
                </td>
                <td>
                    {startup?.hq_data?.name || <span className="funds-raised-table__empty">–</span>}
                </td>
                <td>
                    {startup?.primary_industry_data?.name || <span className="funds-raised-table__empty">–</span>}
                </td>
                <td>
                    {startup?.funding_stage_data?.name
                        ? <span className="fr-status-badge fr-status-badge--closed">{startup.funding_stage_data.name}</span>
                        : <span className="funds-raised-table__empty">–</span>}
                </td>
                <td>
                    {getStartupStatusBadge(startup)}
                </td>
                <td>
                    {website
                        ? (
                            <a className="funds-raised-table__fund-link fp-website-link" href={website.href} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-link mr-1" />
                                {website.display}
                            </a>
                        )
                        : <span className="funds-raised-table__empty">–</span>}
                </td>
            </tr>
        );
    });

export default FundPortfolioTableBody;
